import {
  ITimepickerFieldConfigurationClient,
  ITimepickerFieldConfigurationServer,
} from "./interface";

export const transformTimePickerFieldConfigClientToServer = (
  fieldConfigClient: ITimepickerFieldConfigurationClient
): ITimepickerFieldConfigurationServer => {
  const { initialValue, writeJavascript, isCurrentTimeSelected, timeInitialValueType, isRegularTimeFormat,
    fromTimeFieldId,
    toTimeFieldId, isTimeOfDayRequired,timeOfDayFieldId, timeOfDayConfig } = fieldConfigClient;
  const fieldConfigServer = {
    initialValue: initialValue,
    writeJavascript: writeJavascript,
    isCurrentTimeSelected: isCurrentTimeSelected,
    timeInitialValueType: timeInitialValueType,
    isRegularTimeFormat: isRegularTimeFormat,
    fromTimeFieldId: fromTimeFieldId,
    toTimeFieldId: toTimeFieldId,
    isTimeOfDayRequired: isTimeOfDayRequired,
    timeOfDayFieldId: timeOfDayFieldId,
    timeOfDayConfig: timeOfDayConfig,
  };
  return fieldConfigServer;
};

export const transformTimePickerFieldConfigServerToClient = (
  fieldConfigServer: ITimepickerFieldConfigurationServer
): ITimepickerFieldConfigurationClient => {
  const { initialValue, writeJavascript, isCurrentTimeSelected, timeInitialValueType, isRegularTimeFormat,
    fromTimeFieldId,
    toTimeFieldId, isTimeOfDayRequired, timeOfDayFieldId, timeOfDayConfig} = fieldConfigServer;
  const fieldConfigClient = {
    initialValue: initialValue,
    writeJavascript: writeJavascript,
    isCurrentTimeSelected: isCurrentTimeSelected,
    timeInitialValueType: timeInitialValueType,
    isRegularTimeFormat: isRegularTimeFormat,
    fromTimeFieldId: fromTimeFieldId,
    toTimeFieldId: toTimeFieldId,
    isTimeOfDayRequired: isTimeOfDayRequired,
    timeOfDayFieldId: timeOfDayFieldId,
    timeOfDayConfig: timeOfDayConfig,
  };
  return fieldConfigClient;
};

export const setInitialValue = "Set Initial Value";
export const currentTime = "Current Time";
